import { createVNode as d, mergeProps as l } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AddFilled.js";
import m from "../components/PfIcon.js";
const r = (e, t) => {
  const o = {
    ...e,
    ...t.attrs
  };
  return d(m, l(o, {
    icon: i
  }), null);
};
r.displayName = "AddFilled";
r.inheritAttrs = !1;
export {
  r as default
};
